import { Injectable } from '@angular/core';

import { Observable, from } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import apiconfig from '../apiconfig';

@Injectable({
  providedIn: 'root'
})
export class GestpayService {

  constructor(
    private http: HttpClient
  ) { }

  public encrypt(idToken, amount, transactionID): Observable<any> {

    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': idToken,
        'amount': amount,
        'tid': transactionID
      })
    };

    return from(
      this.http.post(apiconfig.endpoint + "/gestpayencrypt",{ "aaa":"bbb" },httpOptions),
    ).pipe(
      tap(() => console.log("encrypt"))
    );

  } // end encrypt

}
